// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueAnalytics from 'vue-analytics'

import '@fortawesome/fontawesome-free/css/fontawesome.css'

// 使用するカテゴリーのファイルを import
import '@fortawesome/fontawesome-free/css/brands.css'
import '@fortawesome/fontawesome-free/css/regular.css'
import '@fortawesome/fontawesome-free/css/solid.css'

import 'quasar-framework/dist/umd/quasar.mat.css'

import Quasar, { QLayout, QInput, QBtn, QLayoutFooter, QTabs, QTab, QTabPane, QFab, QFabAction, QRouteTab, QTable, QSlider, QList, QListHeader, QItem, QItemMain, QItemSeparator, QItemSide, QItemTile, QChipsInput, QBtnDropdown, QProgress, QTd, QCheckbox} from 'quasar-framework/dist/quasar.mat.esm'
Vue.use(Quasar, { components: [QLayout, QInput, QBtn, QLayoutFooter, QTabs, QTab, QTabPane, QRouteTab, QTable, QSlider, QList, QListHeader, QItem, QItemMain, QItemSeparator, QItemSide, QItemTile, QChipsInput, QFab, QFabAction, QBtnDropdown, QProgress, QTd, QCheckbox] })

Vue.config.productionTip = false

Vue.use(VueAnalytics, {
  id: 'UA-128259425-1',
  router
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
  store
})



// WEBPACK FOOTER //
// ./src/main.js